import React from "react";
import { Link } from "react-router-dom";

export default function ShopStripeRefresh() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white border border-gray-200 rounded-xl p-6 shadow-sm text-center">
        <h1 className="text-2xl font-bold text-gray-900">Stripe onboarding not finished</h1>
        <p className="text-gray-600 mt-2">
          Please start onboarding again from your dashboard to complete setup.
        </p>
        <Link
          to="/shop/dashboard"
          className="inline-block mt-5 px-4 py-2 rounded-lg bg-gray-900 text-white hover:bg-black"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}